const initGraduateVideo = () => {
  const openGraduateVideoButton = document.querySelector("[data-video-inline]");  
  if (!openGraduateVideoButton) return;

  openGraduateVideoButton.addEventListener("click", () => {
    setTimeout(() => {
      const modalCloseButton = document.querySelector(".graduates__modal .close-modal");
      const modalVideo = document.querySelector(".graduates__modal video");
      const playVideo = document.querySelector(".graduates__modal .graduates__modal-play");
      modalCloseButton.addEventListener("click", () => {
        modalVideo.pause();
      });
      playVideo.addEventListener("click", () => {
        modalVideo.play();
        playVideo.style = "display: none;";
      });
      modalVideo.addEventListener("click", () => {
        modalVideo.play();
        playVideo.style = "display: none;"
        if (!modalVideo.paused) {
          modalVideo.pause();
          playVideo.style = null;
        }
      });
    })
    
  })
};

export default initGraduateVideo;
